// Every product and category landing page. App.js routes each one to Home,
// and scripts/inline-static-hero.js renders a static hero for each, so the two
// can never disagree about which URLs are landing pages.
export const LANDING_PATHS = [
  '/',
  '/car-insurance-quote/',
  '/funeral-insurance-quote/',
  '/life-insurance-quote/',
  '/medical-aid-quote/',
  '/pet-insurance-quote/',
  '/motor-warranty/',
  '/dents-and-scratches-quote/',
  '/travel-insurance/',
  '/medical-gap-cover-quote/',
  '/medical-insurance-quotes/',
  '/buildings-insurance-quote/',
  '/business-insurance-quote/',
  '/service-plan-quotes/',
  '/vehicle-tracking-quote/',
  '/tyre-and-rim-guard/',
  '/compare-fibre-deals/',
  '/motorcycle-insurance-quote/',
  '/home-insurance-quote/',
  '/personal-loans/',
  '/debt-counselling/',
  '/debt-consolidation-loans/',
  '/business-insurance-quote/car-and-commercial-property-insurance/',
  '/employee-benefits-quote/',
  '/business-insurance-quote/business-legal-cover/',
  '/business-insurance-quote/professional-liability-insurance-cover/',
  '/business-insurance-quote/event-liability-insurance/',
  '/life-insurance-quote/life-insurance-companies/',
  '/car-insurance-quote/companies/',
  '/medical-aid-quote/medical-aid-companies/',
  '/online-insurance-quote/',
  '/insurance/',
  '/motor/',
  '/health/',
  '/money/',
  '/internet/',
];
